const IMPLEMENT_TYPES = [
  {
    type: "TRUCK",
    shaftQuantity: 3,
    grossCapacity: 23,
    netCapacity: 16
  },
  {
    type: "BITRUCK",
    shaftQuantity: 4,
    grossCapacity: 29,
    netCapacity: 19
  },
  {
    type: "TOCO",
    shaftQuantity: 5,
    grossCapacity: 41,
    netCapacity: 28
  },
  {
    type: "ROMEU & JULIETA",
    shaftQuantity: 6,
    grossCapacity: 50,
    netCapacity: 32
  },
  {
    type: "LS (MENOR 16 MT)",
    shaftQuantity: 6,
    grossCapacity: 45,
    netCapacity: 31
  },
  {
    type: "LS (MAIOR 16 MT)",
    shaftQuantity: 6,
    grossCapacity: 48,
    netCapacity: 33
  },
  {
    type: "VANDERLEIA",
    shaftQuantity: 6,
    grossCapacity: 53,
    netCapacity: 36
  },
  {
    type: "BITREM 7 EIXOS",
    shaftQuantity: 7,
    grossCapacity: 57,
    netCapacity: 42
  },
  {
    type: "BITREM 8 EIXOS",
    shaftQuantity: 8,
    grossCapacity: 65,
    netCapacity: 46
  },
  {
    type: "RODOTREM 9 EIXOS",
    shaftQuantity: 9,
    grossCapacity: 74,
    netCapacity: 52
  },
  {
    type: "RODOTREM 11 EIXOS",
    shaftQuantity: 11,
    grossCapacity: 91,
    netCapacity: 65
  }
] as const;

export { IMPLEMENT_TYPES };
